// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"751":"f68d65bc","823":"442e0d53"}[chunkId] + ".chunk.js";
};